import classnames from 'classnames/bind'
import Link from 'next/link'
import { ReactNode } from 'react'

// Constants
import { ROUTE_PATH } from '@/constants/routePath'

// Components
import Icon from '@/assets/icons'
import Button from '@/components/common/livemallclub/Button'
import AboutPageLayout from './utils/AboutPageLayout'
import FeatureList from './utils/FeatureList'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

type SectionType = {
  title: ReactNode
  content: ReactNode
}

const sections: SectionType[] = [
  {
    title: 'About Live Mall Club',
    content: (
      <>
        <p>
          <b>Live Mall Club</b> is an exclusive, members-only multi-live interactive shopping platform meticulously crafted to deliver a high-quality,
          zero-disturbance shopping environment. By invitation only, you can engage in real-time face-to-face interactions with our curated sellers
          and prominent Key Opinion Leaders (KOLs), enjoying zero-distance immersive shopping and live experiences.
        </p>
        <p>
          Through diverse interactive methods, easily ask questions and gain in-depth product information, bridging the gap between you and the
          product. Elevating your experience further, our valued VIP members gain access to exclusive VIP live streams, enjoying early previews of
          unique products and engaging in deeper, more personalized interactions with KOLs.
        </p>
      </>
    ),
  },
  {
    title: 'Our Vision',
    content:
      'At Live Mall Club, we envision a future where exclusive access meets immersive live commerce, creating unparalleled engagement and a seamless shopping journey for our members.',
  },
  {
    title: 'What We Offer',
    content: <FeatureList />,
  },
  {
    title: 'Our Commitment',
    content: (
      <>
        <p>
          We are committed to providing an exclusive, high-quality, and zero-disturbance live shopping experience, fostering direct connections
          between our curated sellers, influential KOLs, and discerning members.
        </p>
        <p>
          Through diverse interactive methods, easily ask questions and gain in-depth product information, bridging the gap between you and the
          product. Elevating your experience further, our valued VIP members gain access to exclusive VIP live streams, enjoying early previews of
          unique products and engaging in deeper, more personalized interactions with KOLs.
        </p>
      </>
    ),
  },
]

const About = () => {
  return (
    <AboutPageLayout>
      <div className={cx('section')}>
        {sections.map((section, index) => (
          <div key={index}>
            <AboutPageLayout.SectionTitle>{section.title}</AboutPageLayout.SectionTitle>
            <div className={cx('section__content')}>{section.content}</div>
          </div>
        ))}
      </div>
      <Button
        theme='pink'
        styles={{
          width: 'fit-content',
        }}
        onClick={() => (window.location.href = 'mailto:shopservice@tutorabcshop.com')}
      >
        <div className={cx('contact-us-icon')}>
          <Icon.Email_bf1424 />
        </div>
        Contact Us
      </Button>
      <div className={cx('terms')}>
        <Link href={ROUTE_PATH.ABOUT_TERMS}>Live Mall Club Terms of Use</Link>
        <Link href='/'>Live Mall Club Privacy Policy</Link>
      </div>
    </AboutPageLayout>
  )
}

export default About
